import React, { useContext } from 'react';
import toast from 'react-hot-toast';
import { Button } from '@nextui-org/react';
import { IconClipboard, IconFileDownload, IconPrinter } from '@tabler/icons-react';
import { AuthContext } from '../../../context';
import { QRImage } from '../../../components';
import { Logo } from '../../../assets/images';
import { fromPhotos, getReferralURL } from '../../../utils';

const StoreHome = () => {
  const { user } = useContext(AuthContext);

  const onCopy = (content) => {
    navigator.clipboard.writeText(content);
    toast.success('Código copiado al portapapeles');
  }

  const download = async () => {
    const link = document.createElement('a');
    link.href = fromPhotos(user.marketing_qr_file);
    link.download = true;
    link.target = '_blank';
    link.click();
    link.remove();
  }

  const printOLD = () => {
    const printContent = document.getElementById('qr-image').innerHTML;
    const printArea = document.getElementById('print-area');
    printArea.innerHTML = printContent;
    window.print();
    printArea.innerHTML = '';
  }

  const print = () => {
    const source = document.getElementById('qr-image');
    const printArea = document.getElementById('print-area');

    // Limpieza preventiva
    printArea.innerHTML = '';

    const canvas = source.querySelector('canvas');

    if (canvas) {
      // Convertir canvas a imagen
      const dataUrl = canvas.toDataURL('image/png'); // Especificar formato ayuda al rendimiento

      // Crear elemento de imagen real
      const img = new Image();
      img.src = dataUrl;
      img.style.width = '100%';
      img.style.maxWidth = '300px';

      // EVENTO CLAVE: Esperar a que la imagen esté decodificada y lista
      img.onload = () => {
        printArea.appendChild(img);

        // Pequeño delay de seguridad post-renderizado (a veces necesario en iOS)
        setTimeout(() => {
          window.print();

          // Limpieza diferida
          setTimeout(() => {
            printArea.innerHTML = '';
          }, 1000);
        }, 50);
      };

      // Manejo de errores por si la imagen falla
      img.onerror = () => {
        console.error("Error al generar la imagen del QR para impresión");
        alert("No se pudo generar la vista previa de impresión.");
      };

    } else {
      // Fallback si no hay canvas (ej. es un img o svg)
      printArea.innerHTML = source.innerHTML;
      setTimeout(() => window.print(), 200);
    }
  };

  return (
    <div className="mx-auto max-w-96">
      <div className="mx-auto bg-white p-4 rounded-lg shadow-lg">
        <div id="qr-image">
          <img src={Logo} className="w-36 object-contain mx-auto hidden printable" alt="logo" />

          <div className="mt-4 flex justify-center items-center gap-4">
            <QRImage
              image={fromPhotos(user.marketing_qr_file)}
              showExpand
              name={user.fullName}
            />
          </div>

          <p className="mt-4 text-sm text-primary break-all unprintable">
            {getReferralURL(user.marketing_qr_id)}
          </p>
        </div>

        <div className="mt-8 flex justify-center items-center gap-4">
          <Button
            color="primary"
            className="font-semibold pl-2"
            startContent={<IconFileDownload />}
            onClick={download}
          >
            Descargar
          </Button>

          <Button
            color="primary"
            className="font-semibold pl-2"
            startContent={<IconClipboard />}
            onPress={() => onCopy(getReferralURL(user.marketing_qr_id))}
          >
            Copiar
          </Button>

          <Button
            color="primary"
            className="font-semibold pl-2"
            variant="bordered"
            startContent={<IconPrinter />}
            onClick={print}
          >
            Imprimir
          </Button>
        </div>
      </div>
    </div>
  );
}

export default StoreHome;
